import { Button } from 'components/Button';
import {
  IconCalendar,
  IconCosts,
  IconDuration,
  IconInvestment,
  IconLevel,
  IconLocation,
  IconMail,
  IconParticipants,
  IconPhone,
  IconStart,
  IconWebsite,
} from 'components/Icons';
import { Link } from 'components/Link';
import { MaxWidth } from 'components/MaxWidth';
import { StarRating } from 'components/StarRating';
import styles from './Meta.module.css';

export const Meta = ({
  buttons,
  meta,
  reviewsAmount,
  reviewsRating,
  reviewsLink,
}) => (
  <div className={styles.container}>
    <MaxWidth>
      <div className={styles.metaContainer}>
        {meta.map((item) => {
          if (!item.value) return null;
          return <MetaItem key={item.label} {...item} />;
        })}
      </div>
      {((buttons && buttons.length > 0) || reviewsLink) && (
        <div className={styles.actionsContainer}>
          {buttons &&
            buttons.map((button) => (
              <Button key={button.label} {...button}>
                {button.label}
              </Button>
            ))}
          {reviewsLink && (
            <Link document={reviewsLink} className={styles.ratingContainer}>
              <StarRating rating={reviewsRating} />
              <span className={styles.ratingLink}>
                {reviewsAmount} {reviewsAmount === 1 ? 'review' : 'reviews'}
              </span>
            </Link>
          )}
        </div>
      )}
    </MaxWidth>
  </div>
);

const MetaItem = ({ icon, label, value, url }) => {
  const icons = {
    calendar: IconCalendar,
    costs: IconCosts,
    duration: IconDuration,
    investment: IconInvestment,
    level: IconLevel,
    location: IconLocation,
    mail: IconMail,
    participants: IconParticipants,
    phone: IconPhone,
    start: IconStart,
    website: IconWebsite,
  };

  const Icon = icons[icon] || IconDuration;

  return (
    <div className={styles.metaItem}>
      <div className={styles.metaItemIconContainer}>
        <Icon />
      </div>
      <div>
        <div>{label}</div>
        <div className={styles.metaItemValue}>
          {!url ? value : <Link href={url}>{value}</Link>}
        </div>
      </div>
    </div>
  );
};
